import cities from '~/data/fakeCities';

// Cities part
const citiesOptions = cities.map(c => {
  return {
    label: c.name,
    value: c.name,
  };
});
const selectedCity = cities.filter(c => c.selected)[0];
// End cities part

const filters = [
  {
    name: 'cities',
    value: selectedCity.name,
    type: 'select',
    options: citiesOptions,
    label: 'Город',
  },
  // FIXME: add more filters
  // {
  //   name: 'days',
  //   value: 'All',
  //   type: 'select',
  //   options: [
  //     { label: 'Все типы', value: 'All' },
  //   ],
  //   label: 'Дни',
  // },
  // {
  //   name: 'flow',
  //   value: 'All',
  //   type: 'select',
  //   options: [
  //     { label: 'Все типы', value: 'All' },
  //   ],
  //   label: 'Поток',
  // },
];

export default filters;
